<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">学期管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="基地名称">
          <el-input v-model="formInline.name" @blur="handleQuery" placeholder="请输入基地名称"></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button type="primary" @click="handleQuery">查询</el-button> -->
          <el-button type="primary" @click="handleAdd()">新增学期</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载用户导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params"     :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column prop="year" label="学年" width="150">
        </custom-table-column>
        <custom-table-column prop="term" label="学期" width="150">
        </custom-table-column>
        <custom-table-column prop="begin_time" label="开始日期" width="150">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束日期" width="150">
        </custom-table-column>
        <custom-table-column prop="week_begin_time" label="周次开始日期" width="150">
        </custom-table-column>
        <custom-table-column prop="week_end_time" label="周次结束日期" width="150">
        </custom-table-column>
        <custom-table-column label="是否默认学期" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_defined == 1" style="color: var(--blue);">是</span>
            <span v-else style="color:var(--red)">否</span>
          </template>
        </custom-table-column>
        <custom-table-column label="是否停用" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.disabled == 1" style="color: var(--blue);">是</span>
            <span v-else style="color:var(--red)">否</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button v-if="scope.row.disabled == 1" @click="handleApply(scope.row.id, '0', '启用')" type="text"
              size="small">启用</el-button>
            <el-button v-else @click="handleApply(scope.row.id, '1', '停用')" type="text" size="small">停用</el-button>
            <el-button v-if="scope.row.is_defined != 1" @click="handleSetDefined(scope.row.id)" type="text"
              size="small">设为默认</el-button>
            <el-button @click="handleWeek(scope.row)" type="text" size="small">查看周次</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="学年" prop="year">
          <el-input v-model="ruleForm.year" placeholder="格式（2020-2021学年）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="学期" prop="term">
          <el-select v-model="ruleForm.term" clearable filterable placeholder="请选择学期" style="width:216px;">
            <el-option v-for="item in $store.state.term" :key="item.value" :label="item.label"
              :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="begin_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" v-model="ruleForm.begin_time"
            @change="handleBeginTimeChange" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="end_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" v-model="ruleForm.end_time"
            @change="handleEndTimeChange" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="周次开始日期" prop="week_begin_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择周次开始日期"
            v-model="ruleForm.week_begin_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="周次结束日期" prop="week_end_time">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择周次结束日期" v-model="ruleForm.week_end_time"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="type == 'add'" label="是否默认学期" prop="is_defined">
          <el-switch v-model="ruleForm.is_defined" :active-value="1" :inactive-value="0" active-text="是"
            inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="周次管理" :visible.sync="weekDialogVisible" width="700px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="60">
          </custom-table-column>
          <custom-table-column prop="name" label="周次" width="100">
          </custom-table-column>
          <custom-table-column prop="begin_date" label="开始日期" min-width="120">
          </custom-table-column>
          <custom-table-column prop="end_date" label="结束日期" min-width="120">
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="weekPage" @getList="getWeekList"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="weekDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true" show-checkbox :default-checked-keys="checkKeys" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {

    return {
      classRooms: [],

      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      levell: [1],
      formInline: {
        name: '',
      },
      ruleForm: {
        year: '',
        term: '',
        begin_time: '',
        end_time: '',
        week_begin_time: '',
        week_end_time: '',
        is_defined: 0,
      },
      formInline1: {
        id: ''
      },
      weekDialogVisible: false,
      total1: 0,
      tableData1: [],
      treeData: '',
      rules: {
        year: [{ required: true, message: '请输入学年', trigger: 'blur' }],
        term: [{ required: true, message: '请选择学期', trigger: 'change' }],
        begin_time: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        week_begin_time: [{ required: true, message: '请选择周次开始日期', trigger: 'change' }],
        week_end_time: [{ required: true, message: '请选择周次结束日期', trigger: 'change' }],


        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
    };
  },
  created() {
  },
  mounted() {
    // this.getList();
    this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleApply(id, status, str) {
      this.confirmBox('warning', `此操作将${str}该学期，是否继续`, { id, disabled: status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer('api/school_year/disable', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    handleSetDefined(id) {
      this.confirmBox('warning', '确定要将该学期设为默认学期吗？', { id }, this.setDefined);
    },
    async setDefined(params) {
      let res = await this.$api.instance.interfaceServer('api/school_year/setDefined', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.getList();
      }
    },
    handleWeek(row) {
      this.formInline1.school_year_id = row.id;
      this.tableData1 = [];
      this.weekDialogVisible = true;
      this.$nextTick(() => {
        this.handleQueryWeek();
      });

    },
    handleQueryWeek() {
      this.$refs.weekPage.page = 1;
      this.getWeekList();
    },
    async getWeekList() {
      let params = { ...this.formInline1 };
      params.page = this.$refs.weekPage.page;
      params.size = this.$refs.weekPage.size;
      let res = await this.$api.instance.interfaceServer('api/school_year/week', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },


    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    getOrganList() {
      if (this.selectNode.level == 1) {
        this.ruleForm.structure_1 = this.selectNode.structure_names;
      } else {
        this.ruleForm.structure_1 = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/school_year/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/school_year/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/school_year/update', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleBeginTimeChange(val) {
      // 选择开始日期时，自动填充周次开始日期
      this.ruleForm.week_begin_time = val;
    },
    handleEndTimeChange(val) {
      // 选择结束日期时，自动填充周次结束日期
      this.ruleForm.week_end_time = val;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/school_year/index', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: 96px;
}
</style>
